import makeStyles from '@mui/styles/makeStyles';

export const usePlansStyles = makeStyles((theme) => ({
    background: {
        backgroundColor: theme.palette.background.default,
    },
    backDrop: {
        backdropFilter: 'blur(3px)',
        backgroundColor: 'rgba(0,0,30,0.4)',
    },
    dialogTitle: {
        textAlign: 'center',
        padding: '10px',
    },
    dialogContent: {
        width: '100%',
    },
    switchBackground: {
        // backgroundColor: theme.palette.background.paper,
        paddingLeft: '5px',
        padding: '0 3px',
        borderRadius: '5px',
        marginRight: '-5px',
    },
    letterRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
    },
    letterRowStaticColor: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        backgroundColor: 'grey',
    },
    columnRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
    },
    switchRow: {
        border: `1px solid ${theme.palette.mode === 'light' ? '#BFC2C7' : '#ACAFB3'}`,
        backgroundColor: theme.palette.inPatient.inputBackground,
        borderRadius: 6,
        overflow: 'hidden',
    },
    propertyListOptionRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 10px',
    },
    patientBanner: {
        backgroundColor: '#C6C6C6',
        paddingTop: '5px',
        paddingBottom: '5px',
        borderRadius: '10px',
        marginBottom: '10px',
    },
    whiteBorderContainer: {
        border: '1px solid #f9f9f9',
        borderRadius: '10px',
        overflow: 'hidden',
        width: '100%',
    },
    switchContainerComment: {
        background: 'gray',
        marginLeft: '0 !important',
        marginBottom: '-4px !important',
    },
    nonContactCellTypography: {
        '&.MuiTypography-root:hover': {
            borderRadius: '10px',
            cursor: 'pointer',
        },
    },
    descriptionBox: {
        backgroundColor: theme.palette.inPatient.formBackground,
        textAlign: 'center',
        borderRadius: '10px',
    }
}));